import React from 'react'
import View from './view'
import {Divisions} from '../../../constants/divisions'
import {StudyGuide} from '../../../redux/studyGuides'
import {Attempt} from '../../../redux/reportExamStatus'

type Props = {
  division: Divisions
  courseId?: string
  studyGuides?: StudyGuide[]
  source?: 'card' | 'page'
  reportStatus?: Attempt
}

const DivisionProgress = ({
  division,
  courseId,
  studyGuides,
  source,
  reportStatus,
}: Props) => {
  return (
    <View
      division={division}
      courseId={courseId}
      studyGuides={studyGuides}
      source={source}
      reportStatus={reportStatus}
    />
  )
}

export default DivisionProgress
